module.exports = __webpack_public_path__ + "static/img/bg-id.7e64aa35.png";